<template>
  <div class="home">
    <NavbarMain />
    <div class="container py-5">
      <div class="cart-container shadow rounded p-5">
        <h6 v-if="sacoins > -1 && financiamiento > -1" class="text-center">
          Sacoins: $SC{{ sacoins.toFixed(2) }}, Financiamiento permitido: $SC{{ financiamiento.toFixed(2) }}
        </h6>
        <h6 v-else class="text-center">
          Sacoins:
          <div class="spinner-border spinner-border-sm" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          , Financiamiento permitido:
          <div class="spinner-border spinner-border-sm" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </h6>
        <ShippingInfo v-if="cartItems.length && steep == 0" />
        <SetShippingInfo v-if="cartItems.length && steep == 1" />
        <PaymentDetail v-if="cartItems.length && steep == 2" />
      </div>
    </div>
    <ModalRefreshToken />
  </div>
</template>


<script>
import NavbarMain from "@/components/NavbarMain.vue";
import ShippingInfo from "../components/cart/ShippingInfo";
import SetShippingInfo from "../components/cart/SetShippingInfo";
import PaymentDetail from "../components/cart/PaymentDetail";
import ModalRefreshToken from "../components/modals/ModalRefreshToken.vue"

import { mapState } from "vuex";
import Api from "../tools/Api2";
import { LC } from "../tools/exchange";

export default {
  name: "Buy",
  components: {
    NavbarMain,
    ShippingInfo,
    SetShippingInfo,
    PaymentDetail,
    ModalRefreshToken
  },
  data() {
    return {
      localCurrency: null,
      /* */
      sacoins: -1,
      financiamiento: -1,
      cartItems: [],
      steep: 0,
      shippingAutocomplete: {},
      inputs: {
        shipping: {
          pais: {
            value: "MEX",
            required: true,
          },
          estado: {
            value: "",
            required: true,
          },
          colonia: {
            value: "",
            required: true,
          },
          ciudad: {
            value: "",
            required: true,
          },
          calle: {
            value: "",
            required: true,
          },
          numeroInt: {
            value: "",
            required: true,
          },
          numeroExt: {
            value: "",
            required: true,
          },
          codigoPostal: {
            value: "",
            required: true,
          },
          telefono: {
            value: "",
            required: true,
          },
          referencias: {
            value: "",
            required: false,
          },
        },
      },
    };
  },
  methods: {
    productSCPrice(price, currency) {
      if (!this.localCurrency) return 0;
      return this.localCurrency.localToSC({ price, currency });
    },
    backSteep(i = 1) {
      if (this.steep == 0) {
        this.$router.push({ path: "/carrito" });
      } else {
        this.steep -= i;
      }
    },
    nextSteep(i = 1) {
      this.steep += i;
    },
    autoCompleteForms() {
      this.inputs.shipping.pais.value = this.shippingAutocomplete.pais
        ? this.shippingAutocomplete.pais
        : this.inputs.shipping.pais.value;
      this.inputs.shipping.calle.value = this.shippingAutocomplete.calle
        ? this.shippingAutocomplete.calle
        : this.inputs.shipping.calle.value;
      this.inputs.shipping.ciudad.value = this.shippingAutocomplete.ciudad
        ? this.shippingAutocomplete.ciudad
        : this.inputs.shipping.ciudad.value;
      this.inputs.shipping.estado.value = this.shippingAutocomplete.estado
        ? this.shippingAutocomplete.estado
        : this.inputs.shipping.estado.value;
      this.inputs.shipping.codigoPostal.value = this.shippingAutocomplete.cp
        ? this.shippingAutocomplete.cp
        : this.inputs.shipping.codigoPostal.value;
      this.inputs.shipping.numeroExt.value = this.shippingAutocomplete.nroExt
        ? this.shippingAutocomplete.nroExt
        : this.inputs.shipping.numeroExt.value;
      this.inputs.shipping.numeroInt.value = this.shippingAutocomplete.nroInt
        ? this.shippingAutocomplete.nroInt
        : this.inputs.shipping.numeroInt.value;
      this.inputs.shipping.telefono.value = this.shippingAutocomplete.telefono
        ? this.shippingAutocomplete.telefono
        : this.inputs.shipping.telefono.value;
    },
  },
  computed: {
    ...mapState(["cart", "auth", "changes"]),
    totalCart() {
      const reducer = (acc, item) => {
        let productPrice = this.productSCPrice(item.price, item.currency);
        return (
          acc + productPrice * item.amountInCart * (1 - item.discount / 100)
        );
      };
      return this.cartItems.reduce(reducer, 0).toFixed(2);
    },
  },
  created: function () {
    LC.new().then((localCurrency) => (this.localCurrency = localCurrency));

    let promise = new Promise((resolve, reject) => {
      let arr = [];
      for (const item in this.cart.items) {
        Api(this.cart.items[item].kind)
          .get(this.cart.items[item].id)
          .then((res) => {
            arr.push({
              ...res[this.cart.items[item].kind],
              amountInCart: this.cart.items[item].amount,
              image: res[this.cart.items[item].kind].images[0],
              kind: this.cart.items[item].kind,
              options: this.cart.items[item].options,
            });
            if (item == this.cart.items.length - 1) resolve(arr);
          })
          .catch(() => reject);
      }
    });

    promise.then(items => {
      this.cartItems = items;
    })
  /*
    this.cart.items.forEach((item) => {
      Api(item.kind)
        .get(item.id)
        .then((res) => {
          this.cartItems.push({
            ...res[item.kind],
            amountInCart: item.amount,
            image: res[item.kind].images[0],
            kind: item.kind,
            options: item.options,
          });
        });
    });
    */

    Api("sistem-apple")
      .get("address")
      .then((res) => {
        this.shippingAutocomplete = res;
      });

    Api("sistem-apple")
      .get("get-saldo")
      .then((res) => {
        this.sacoins = res.saldo;
        this.financiamiento = res.maxFinanciacion;
        this.codigoPostal = res.cp;
      });
  },
};
</script>

